<template>
  <div>
    <b-alert
      v-for="finding in findings"
      :key="finding.code"
      show
      :variant="severityVariants[finding.severity]"
      class="mb-1"
    >
      <div class="alert-body d-flex align-items-center justify-content-between flex-wrap">
        <span>
          <strong>{{ finding.code }}</strong> — {{ finding.message }}
          <small
            v-if="finding.action === 'refund'"
            class="d-block"
          >{{ actionLabels.refund }}</small>
        </span>
        <b-button
          v-if="canDo(finding.action)"
          size="sm"
          variant="outline-dark"
          class="ml-1"
          :disabled="busy"
          @click="$emit('action', finding.action)"
        >
          {{ actionLabels[finding.action] }}
        </b-button>
      </div>
    </b-alert>
    <p
      v-if="!findings.length"
      class="text-muted"
    >
      Замечаний нет
    </p>
  </div>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'
import { ACTION_LABELS, SEVERITY_VARIANTS } from '../payment-labels'

export default {
  name: 'PaymentFindings',
  components: { BAlert, BButton },
  props: {
    findings: { type: Array, default: () => [] },
    busy: { type: Boolean, default: false },
  },
  data() {
    return { severityVariants: SEVERITY_VARIANTS, actionLabels: ACTION_LABELS }
  },
  methods: {
    // refund is a manual step: nothing here refunds
    canDo(action) {
      return ['reapply', 'link_entity', 'recheck'].includes(action)
    },
  },
}
</script>
